/// <reference types="vite/client" />
import '../tailwind/input-guest.css'
import { usePostHog } from './common/composables/usePostHog'
import { RouterPlugin } from './router/RouterPlugin'
import { mkGuestRouter } from './router/guest-router'
import { useSettingStore } from './stores/setting'
import 'external-svg-loader'
import { createPinia, setActivePinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'

import AppGuest from '@/AppGuest.vue'
import { configureBrowserAxios } from '@/api/browser'
import { mkBrowserSentry } from '@/sentry'

configureBrowserAxios()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const router = mkGuestRouter()
pinia.use(RouterPlugin(router))
setActivePinia(pinia)

// Hydrate from SSR-injected state before any useStore() call. The script tag
// lives at the end of <body> (SSRPreload.vue) so it runs before this deferred
// module bundle. Persisted stores (checkout, terminal) are not in the payload,
// so the persistence plugin's localStorage restore is not at risk of clobbering.
if (typeof window !== 'undefined' && window.__pinia) {
  pinia.state.value = { ...pinia.state.value, ...window.__pinia }
}

const app = createApp(AppGuest)
app.use(pinia)
app.use(router)
const { init: initPostHog } = usePostHog()
initPostHog()

if (import.meta.env.VUE_APP_VERSION) {
  mkBrowserSentry(app, router)
}
useSettingStore().fetch()
router.isReady().then(() => app.mount('#app'))
